/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {ErrorMessage, useFormikContext} from 'formik'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {PhoneInputProps} from 'react-phone-input-2'
import {getSubscriptionPlanList} from '../../../../../setup/redux/auth/actions'
import {RootState} from '../../../../../setup'
import SubscriptionPlanDisplay from '../../../../components/common/SubscriptionPlanDisplay'

const Step3: FC<PhoneInputProps> = () => {
  const formik = useFormikContext()
  const dispatch: Dispatch<any> = useDispatch()
  const [subscriptionType, setSubscriptionType] = useState<'monthly' | 'yearly'>('monthly')
  const [selectedPlan, setSelectedPlan] = useState<any>(null)
  const [isTabSwitching, setIsTabSwitching] = useState(false)
  const [hasSubmitted, setHasSubmitted] = useState(false)

  const {subscriptionPlans}: any = useSelector<RootState>(
    (state) => ({
      subscriptionPlans: state.auth.subscriptionPlans,
    }),
    shallowEqual
  )

  useEffect(() => {
    dispatch(getSubscriptionPlanList())
  }, [])

  useEffect(() => {
    if (isTabSwitching) {
      const timer = setTimeout(() => {
        setIsTabSwitching(false)
        formik.setFieldError('subscription_plan', undefined)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isTabSwitching])

  useEffect(() => {
    const values = formik.values as any
    if (values.subscription_plan) {
      formik.setFieldError('subscription_plan', undefined)
      setHasSubmitted(false) 
    }
  }, [(formik.values as any).subscription_plan])

  useEffect(() => {
    const errors = formik.errors as any
    if (errors.subscription_plan) {
      setHasSubmitted(true)
    }
  }, [(formik.errors as any).subscription_plan])

  const onPlanSelect = (plan: any) => {
    setIsTabSwitching(false) 
    setHasSubmitted(false) 
    setSelectedPlan(plan)
    formik.setFieldValue('selected_plan', plan)
    formik.setFieldValue('subscription_plan', String(plan.id))
    formik.setFieldValue('plan_type', plan.type)
    if (plan.type === 'paid') {
      formik.setFieldValue('subscription_type', subscriptionType)
    } else {
      formik.setFieldValue('subscription_type', undefined)
    }
    formik.setFieldTouched('subscription_plan', true)
    formik.setFieldError('subscription_plan', undefined)
  }

  const handleSubscriptionTypeChange = (type: 'monthly' | 'yearly') => {
    setIsTabSwitching(true)
    setSubscriptionType(type)
    formik.setFieldValue('subscription_type', type)
    formik.setFieldError('subscription_plan', undefined)
  }

  const handleFreePlanGetStarted = () => {
    setIsTabSwitching(false) 
    setHasSubmitted(false) 
    formik.setErrors({})
    formik.setFieldError('subscription_plan', undefined)
    const freePlan = subscriptionPlans.find((plan: any) => plan.type === 'free')
    if (freePlan) {
      setSelectedPlan(freePlan)
      formik.setFieldValue('selected_plan', freePlan)
      formik.setFieldValue('subscription_plan', String(freePlan.id))
      formik.setFieldValue('plan_type', freePlan.type)
      formik.setFieldValue('subscription_type', undefined)
      formik.setFieldTouched('subscription_plan', true)
    }
  }

  return (
    <div className='w-100 mt-2 pt-6 card-body'>
      <div className='pb-8 pb-lg-8 boxTitleHeading'>
        <h2 className='fw-bolder d-flex align-items-center text-dark'>
          Subscription Plans to Fit Any Need!
        </h2>
      </div>
      <SubscriptionPlanDisplay
        selectedType={subscriptionType}
        onTypeChange={handleSubscriptionTypeChange}
        onPlanSelect={onPlanSelect}
        selectedPlan={selectedPlan}
        showActionButtons={false}
        className=''
        subscriptionPlans={subscriptionPlans}
        onFreePlanGetStarted={handleFreePlanGetStarted}
      />

        {hasSubmitted && !(formik.values as any).subscription_plan && !isTabSwitching && (
          <ErrorMessage name='subscription_plan'>
            {(errorMessage) => <div className='text-danger mt-2'>{errorMessage}</div>}
          </ErrorMessage>
        )}
    </div>
  )
}

export {Step3}
